export function getInitials(
  name?: string | null,
  email?: string | null,
  fallback = "?",
): string {
  const source = (name || email || "").trim();
  if (!source) return fallback;
  const parts = source.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return source.slice(0, 2).toUpperCase();
}
